<template>
  <v-row class="full-height pa-0 ma-0">
    <v-col cols="8">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" class="pa-0 ma-0">
          <v-card class="transparent" elevation="0">
            <v-card-title class="px-0">
              <div class="d-flex align-center justify-space-between">
                <div>
                  {{ item.name }}
                </div>

                <v-tooltip v-if="item.Status" location="bottom">
                  <template #activator="{ props }">
                    <v-chip
                      label
                      :color="item.Status.color"
                      v-bind="props"
                      dark
                    >
                      {{ item.Status.name }}
                    </v-chip>
                  </template>
                  <span>{{ item.Status.description }}</span>
                </v-tooltip>
              </div>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col cols="12" class="pa-0 mt-4">
          <v-card>
            <v-tabs v-model="tab" bg-color="transparent" color="primary">
              <v-tab
                :key="'dashboard'"
                :text="'Dashboard'"
                :value="'dashboard'"
              />
              <v-tab
                :key="'metrics'"
                :text="'Metrics'"
                :value="'metrics'"
              />
              <v-tab
                :key="'real-time'"
                :text="'Real Time'"
                :value="'real-time'"
              />

              <v-tab
                :key="'creatives'"
                :text="'Creatives'"
                :value="'creatives'"
              />
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-tabs-window v-model="tab">
            <v-tabs-window-item :key="'dashboard'" :value="'dashboard'">
              <CampaignAnalytics :model-value="item" />
            </v-tabs-window-item>
            <v-tabs-window-item :key="'metrics'" :value="'metrics'">
              <CampaignMetrics :model-value="item" />
            </v-tabs-window-item>
            <v-tabs-window-item :key="'real-time'" :value="'real-time'">
              <v-col cols="12">
                <v-card>
                  <v-card-text>
                    <CampaignRealTimePerformance :height="700" />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-tabs-window-item>
          </v-tabs-window>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="4" class="full-height">
      <CampaignDetailsMainCard v-model="item" />
    </v-col>
  </v-row>
</template>



<script>
import CampaignDetailsMainCard from "@/components/organisms/campaign/CampaignDetailsMainCard.vue";
import { CampaignAPIInstance } from "../../api";
import CampaignRealTimePerformance from "@/components/molecules/campaign/analytics/CampaignRealTimePerformance.vue";
import CampaignAnalytics from "@/components/organisms/campaign/CampaignAnalytics.vue";
import CampaignMetrics from "@/components/organisms/campaign/CampaignMetrics.vue";

export default {
  components: {
    CampaignDetailsMainCard,
    CampaignRealTimePerformance,
    CampaignAnalytics,
    CampaignMetrics,
  },
  props: {},
  emits: ["next", "onDetails"],
  data() {
    return {
      newDialog: false,
      tab: "dashboard",

      chartData: {
        left: [423, 446, 675, 510, 590, 610, 760],
        right: [423, 446, 675, 510, 590, 610, 760],
      },

      item: {
        name: null,
        description: null,
        Website: null,
        PSpot: null,
      },
      data: {
        items: [],
        pagination: {
          page: 1,
          pageSize: 10,
        },
      },
      headers: [
        { title: "ID", key: "id" },
        { title: "Type", key: "Type" },
        { title: "Resolution", key: "resolution" },
        { title: "Status", key: "Status" },
        { title: "Name", key: "name" },
        { title: "Views", key: "Views" },
        { title: "Created", key: "created_at" },
        { title: "Actions", key: "Actions" },
      ],
    };
  },
  computed: {},
  created() {
    this.getItem();
    this.getList();
  },
  methods: {
    async getList() {
      // const { items, pagination } = await Campaignes.list(
      //   this.data.pagination,
      //   {
      //     inventoryItemId: this.$route.params.id,
      //   }
      // );
      // this.data.items = items;
      // this.data.pagination = pagination;
    },
    async getItem() {
      const item = await CampaignAPIInstance.get(this.$route.params.id);
      this.item = item;
    },
    async create(adPlacement) {
      const newPlacement = await CampaignAPIInstance.create(
        {
          ...adPlacement,
          inventory_item_id: this.item.id,
        },
        {
          toast: {
            message: "Ad Placement Created",
            color: "success",
          },
        }
      );

      this.$refs.adPlacementCreationDialog.setPlacement(newPlacement);
    },
    async onDelete(id) {
      await CampaignAPIInstance.delete(id, {
        toast: {
          message: "Ad Placement Deactivated",
          color: "success",
        },
      });

      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.full-height {
  color: rgb(12, 90, 213);
}
</style>